<template>
  <v-container fluid>
    <template>
      <v-breadcrumbs :items="link">
        <template v-slot:link="{ link }">
          <v-breadcrumbs-item :href="link.href" :disabled="link.disabled">
            {{ link.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </template>
    <v-row>
      <v-text-field outlined color="#0482fb" label="Numéro Police ....." class="pt-5 pa-2" v-model="policeNumber"
        prepend-inner-icon="mdi-magnify" dense @change="onEnter" flat background-color="grey lighten-4"></v-text-field>
      <v-text-field outlined color="#0482fb" label="Numéro Avenant ....." class="pt-5 pa-2"
        prepend-inner-icon="mdi-magnify" dense v-model="plugged" @change="onEnter" flat
        background-color="grey lighten-4"></v-text-field>
      <v-select outlined :items="companyNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
        @change="onEnter" v-model="company" flat background-color="grey lighten-4" label="Compagnie ....."></v-select>
    </v-row>

    <template>
      <v-data-table :headers="Avenantheaders" :items="ContractsList" sort-by="calories"
        :loading="loading ? '#0482fb' : null" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Listing Avenants du client : {{ File.name }} pour le produit
              {{ Contract && Contract.product ? Contract.productName : "" }}
            </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>

            <v-btn color="success" pill dark class="mr-2" @click="startNewContract">
              Mise en place nouveau contrat
            </v-btn>
            <v-btn pill class="mr-2" @click="sinisterDialog = true">
              Déclaration sinistre
            </v-btn>

            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5">Etes vous sûrs de vouloire supprimer cet élément
                  ?</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.company="{ item }">
          <td>
            {{ item.company && item.company.name ? item.company.name : "" }}
          </td>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon color="warning" class="mr-10" @click="editItem(item)">
            mdi-pencil-box-multiple-outline</v-icon>

          <v-icon color="red" size="30" class="mr-2" @click="initCancelContract(item)">
            mdi-delete-empty
          </v-icon>
        </template>
      </v-data-table>
    </template>
    <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="cancelDialog">
      <v-card>
        <v-toolbar color="red" dark>Voulez vous vraiment annuler ce contrat</v-toolbar>
        <v-card-text>
          <div class="text-h6 pa-6 pa-md-12">
            Un nouveau contrat sera créé avec la valeur négative des montants
            actuels
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="(cancelDialog = false), (cancelModal = {})">Annuler</v-btn>
          <v-btn color="red" class="white--text" @click="saveCancelContract">Confirmer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- informations Dossier-->
    <template>
      <h2 class="pt-8">Informations client</h2>
      <v-form v-model="valid">
        <v-container>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field outlined color="#0482fb" v-model="File.name" label="Nom / Raison sociale"
                disabled></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field outlined color="#0482fb" v-model="File.phone" label="Téléphone" disabled></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field outlined color="#0482fb" v-model="File.activityField" disabled
                label="Domaine d'activité"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field outlined color="#0482fb" v-model="File.email" disabled label="Mail"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field outlined color="#0482fb" v-model="File.location" disabled label="Localité"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field outlined color="#0482fb" v-model="File.nature" disabled label="Nature"></v-text-field>
            </v-col>
            <v-col v-if="File.birthday" cols="12" md="4">
              <v-text-field outlined color="#0482fb" :value="defaultMethods.getDateFormat(File.birthday)" disabled
                label="Date d'anniversaire"></v-text-field>
            </v-col>
            <!-- <v-col cols="12" md="4">
              <v-text-field outlined  
            color="#0482fb"
                disabled
                v-model="firstName"
                label="Autres détaille ...."
              ></v-text-field>
            </v-col> -->
            <v-container class="d-none" fluid>
              <v-textarea outlined autocomplete="email" disabled v-model="File.observation"
                label="Observation relative au dossier"></v-textarea>
            </v-container>
          </v-row>
        </v-container>
      </v-form>
    </template>
    <template>
      <v-card-title>
        Correspondants
        <v-spacer></v-spacer>
        <v-text-field outlined color="#0482fb" v-model="search" append-icon="mdi-magnify" label="Search" single-line
          hide-details></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="File.prospects" :search="search"></v-data-table>
    </template>

    <!--  Déclaration sinistre-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog v-model="sinisterDialog" hide-overlay transition="dialog-bottom-transition" scrollable
            max-width="1000px">
            <v-card style="border-top:10px solid #0482fb " tile>
              <v-card-text>
                <h2 class="pt-8 pl-3">Prise de déclaration sinsitre</h2>
                <v-container fluid>
                  <v-row align="center">
                    <!-- <v-col cols="12" sm="3">
                      <v-text-field outlined  
            color="#0482fb"
                        v-model="sinisterAskNumber"
                        label="Numéro sinistre DAYO"
                      ></v-text-field>
                    </v-col> -->
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="declarationModal.sinisterCompanyNumber"
                        label="Numéro sinistre compagnie"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="declarationModal.dateOfOccurrence" type="date"
                        label="Date  survenance"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="declarationModal.declarationDate" type="date"
                        label="Date déclaration"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="declarationModal.companyDispatchDate" type="date"
                        label="Date envoi compagnie"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="declarationModal.driverName"
                        label="Nom conducteur"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="declarationModal.conductiveContact"
                        label="Contact conducteur"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="declarationModal.registrationValidationDate"
                        type="date" label="Date retour compagnie"></v-text-field>
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-textarea outlined v-model="declarationModal.circumstance" name="input-7-4"
                        label="Circonstance du sinistre" value=""></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="declarationModal.PSAP" type="number"
                        label="PSAP"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="declarationModal.disasterObject"
                        label="Objet sinistré"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="declarationModal.materialDamageInsured"
                        label="Dommages matériels assuré"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="declarationModal.insuredBodilyInjury"
                        label="Dommages coporels assuré"></v-text-field>
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-textarea outlined v-model="declarationModal.observation" name="input-7-4" label="Observation"
                        value=""></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
                <v-row justify="end">
                  <v-btn tile color="error" text @click="sinisterDialog = false">
                    Fermer
                  </v-btn>
                  <v-btn tile color="success" class="ml-10" @click="saveDeclaration">
                    Enregistrer
                  </v-btn>
                </v-row>
              </v-card-text>

              <div style="flex: 1 1 auto"></div>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </template>
    <!--  Pop up des Contrat-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog v-model="contractDialog" hide-overlay transition="dialog-bottom-transition" scrollable
            max-width="1000px">
            <save-dialog v-if="contractDialog" @success="successSaveContract" @closeDialog="closeContract"
              :modal="contractModal" />
          </v-dialog>
        </v-row>
      </div>
    </template>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages, rules } from "@/utils/data";
import {
  cancelContract,
  addAppointment,
  // updateFile,
  updateAppointment,
  createDeclaration,
  updateContract,
  addContract,
  addIncorporation,
  withdrawProspect,
  addRegulationClause,
  updateRegulationClause,
  addPbClause,
  updatePbClause,
  addCoinsurance,
  updateCoinsurance,
  addCompanyReturn,
  updateCompanyReturn,
} from "@/api/user.js";
import { updateFile } from "@/api/admin.js";
import SaveDialog from "../components/contrat/saveDialog.vue";

export default {
  name: "production",
  components: { SaveDialog },

  data() {
    return {
      cancelModal: {},
      cancelDialog: false,
      defaultMethods,
      reminderMenu: false,
      companyRequestMenu: false,
      companyReturnMenu: false,
      branche: null,
      customerRequestMenu: false,
      customerReturnMenu: false,
      rules,
      switch1: true,
      panel: [],
      tab: null,
      garantietitre: [
        {
          tab: "RESPONSABILITE CIVILE CHEF D'ENTREPRISE",
          content: "Tab 1 Content",
        },
        { tab: "MULTIRISQUE PROFESSIONNELLE", content: "Tab 2 Content" },
        { tab: "GLOBAL DE BANQUE BOA", content: "Tab 3 Content" },
        { tab: "MULTIRISQUE HABITATION", content: "Tab 4 Content" },
        { tab: "TRC", content: "Tab 5 Content" },
        { tab: "IND", content: "Tab 6 Content" },
      ],
      companyReturnHeaders: [
        {
          text: "Compagnie",
          align: "start",
          sortable: false,
          value: "company",
        },
        { text: "Prime nette", value: "netPrime" },
        { text: "Prime TTC", value: "TTCPrime" },
        { text: "Taxe", value: "tax" },
        { text: "Accessoire", value: "accessory" },
        { text: "Date retour", value: "returnDate" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      items: ["NSIA", "SANLAM", "SAHAM", "ATLANTIQUE ASSURANCE"],

      // Catégorie branche
      Au: ["MONO", "FLOTTE"],
      MP: ["MRP", "GD", "TOUT RISQUE SAUF"],
      GB: [
        "FRAUDE",
        "DETOURNEMENT",
        "FRAUDE + DETOURNEMENT",
        "FRAUDE INFORMATIQUE",
      ],
      IA: ["NOMMES", "NON NOMMES"],
      RCCE: ["RC EXPLOITATION", "RC PROF", "RC"],
      AT: ["MARITIME", "TERRESTRE", "AERIEN", "FERROVIAIRE"],

      link: [
        {
          text: "Contrat",
          disabled: false,
          href: "/Contrat",
        },
        {
          text: "Gestion dossier",
          disabled: true,
          href: "breadcrumbs_link_1",
        },
      ],
      natureprospect: ["Physics", "Entreprise"],
      focus: "",
      search: "",
      events: [],
      type: "month",
      typeToLabel: {
        month: "Month",
        week: "Week",
        day: "Day",
        "4day": "4 Days",
      },
      regulation: false,
      PB: false,
      coassurance: false,
      reassurance: false,
      select: "",
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      colors: ["red"],
      names: ["Appel"],
      colorss: ["green"],
      namess: ["Rendez vous"],
      categories: ["John Smith"],
      addgarantie: false,
      dialog: false,
      appelsModal: false,
      callDialog: false,
      appointmentAddDialog: false,
      appointmentDialog: false,
      productDialog: false,
      quotingDialog: false,
      garantie: false,
      contractDialog: false,
      notifications: false,
      sinisterDialog: false,
      sound: true,
      widgets: false,
      prospect: false,
      dialogDelete: false,
      categoriegarantie: [
        {
          titreCatégorie: "I- Responsabilité Civile Exploitation",
          value1: "",
          value2: "",
          Souscategoriegarantie: [
            {
              titreCatégorie: "domage",
              value1: "",
              value2: "",
            },
            {
              titreCatégorie: "domage",
              value1: "",
              value2: "",
            },
          ],
        },
        {
          titreCatégorie: "II- Responsabilité Civile Professionnelle",
          value1: "",
          value2: "",
          Souscategoriegarantie: [
            {
              titreCatégorie: "Domage1",
              value1: "",
              value2: "",
            },
          ],
        },
        {
          titreCatégorie: "III- Défense et Recours",
          value1: "10 000 000",
          value2: "Néant",
        },
      ],
      produitsugest: [
        {
          text: " Liste des produits",
          value: "name",
        },
      ],
      produittake: [
        {
          text: "Liste des produits Proposer",
          value: "nom",
        },
      ],
      headers: [
        {
          text: "Nom et Prénoms ",
          align: "start",
          sortable: false,
          value: "fullName",
        },
        { text: "Contact", value: "contact" },
        { text: "Mail", value: "email" },
        { text: "Date d'anniversaire", value: "birthday" },
        { text: "Type d'influence", value: "affluenceType" },
        // { text: "Actions", value: "actions", sortable: false },
      ],
      Avenantheaders: [
        {
          text: "Date Opération",
          align: "start",
          sortable: false,
          value: "createdAt",
        },
        // { text: "Nature", value: "nature" },
        // { text: "Description", value: "description" },
        { text: "Type avenant", value: "actionType" },
        { text: "Numéro Police", value: "policeNumber" },
        { text: "Numéro Avenant", value: "plugged" },
        { text: "Compagnie", value: "company" },
        { text: "Effet", value: "effectDate" },
        { text: "Echéance", value: "dueDate" },
        { text: "Prime nette", value: "netPrime" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      listproduit: [
        {
          name: "Cart d'identité",
        },
        {
          name: "permis de conduit",
        },
        {
          name: "Atestation de residence",
        },
      ],
      prospectdata: [],
      editedIndex: -1,
      editedItem: {
        nom: "",
        Nature: "",
        Contact: "",
        Activité: "",
        Mail: "",
        Anniverssaire: "",
        Localisation: "",
      },
      defaultItem: {
        nom: "",
        Nature: "",
        Contact: "",
        Activité: "",
        Mail: "",
        Anniverssaire: "",
        Localisation: "",
      },
      incorporationDialog: false,
      categorie: [],
      withDrawModal: false,
      coinsuranceDialog: false,
      reasure: false,
      returnCompagn: false,
      regulationDialog: false,
      pbDialog: false,
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is ",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      callModal: {},
      appointmentModal: {},
      appointmentEvents: [],
      loading: false,
      valid: false,
      firstName: "",

      headersProduct: [
        {
          text: "Nom du produit",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Abréviation", value: "acronym" },
        { text: "Description", value: "description" },
        { text: "", value: "actions", sortable: false },
      ],
      selectedProduct: {},
      currentProduct: null,
      avenantList: [
        "Affaire Nouvelle",
        "Renouvellement",
        "Incorporation",
        "Retrait",
        "Suspension",
        "Remise en vigeur",
        "Precision",
        "Modification",
        "Resiliation",
        "Régularisation",
        "Changement d'immatriculation",
      ],
      proposedProductNameList: [],
      companyNameList: [],
      coinsuranceCompanyNameList: [],
      CommercialNameList: [],
      prospectsNameList: [],

      contractModal: {
        accessory100: 0,
        accessory50: 0,
      },
      incorporationModal: {},
      regulationClauseModal: {
        reminderDate: "",
        companyRequestDate: "",
        companyReturnDate: "",
        customerRequestDate: "",
        customerReturnDate: "",
      },
      pbClauseModal: {
        reminderDate: "",
        companyRequestDate: "",
        companyReturnDate: "",
        customerRequestDate: "",
        customerReturnDate: "",
      },

      coinsuranceModal: [
        {
          shareRate: 0,
          company: "",
          observation: "",
        },
      ],
      customerReturnDialog: false,
      companyReturnDialog: false,
      companyReturnModal: {},
      declarationModal: {},
    };
  },

  mounted() {
    this.init();
    // this.$refs.calendar.checkChange();
  },
  computed: {
    ...mapGetters([
      "File",
      "Products",
      "Companies",
      "Quoting",
      "Users",
      "Contract",
      "FileEndorsements",
      "QuotingRequest",
      "CompanyReturns",
      "ContractsList",
    ]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    QuotingRequest() {
      if (this.QuotingRequest && this.QuotingRequest.product) {
        this.currentProduct = this.QuotingRequest.product._id;

        // console.log(this.QuotingRequest.product._id);

        // this.seedContract();

        this.initQuoting();
      }
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    File() {
      this.seedProposedProduct();

      //  prospects name liste

      this.prospectsNameList = defaultMethods.getNameList(this.File.prospects);
      // get contract
      // this.seedContract();
    },
    contractModal() { },
    Companies() {
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
      this.seedCoinsuranceCompanyNameList();

      if (this.Contract && this.Contract._id) {
        if (this.Companies && this.Companies.docs) {
          this.contractModal.company = defaultMethods.getItemName(
            this.Companies.docs,
            this.contractModal.company
          );
        }
      }
    },
    Users() {
      this.CommercialNameList = defaultMethods.getNameList(this.Users.docs);
    },
    Quoting() {
      if (this.Quoting && this.Quoting._id) {
        this.initCompanyReturn();
        this.declarationModal = {
          _id: this.Quoting._id,
          duration: this.Quoting.duration,
          // netPrime: this.Quoting.netPrime,
          // TTCPrime: this.Quoting.TTCPrime,
          annualRent: this.Quoting.annualRent,
          // dateReturnCustomer: this.Quoting.dateReturnCustomer,
          turnover: this.Quoting.turnover,
          effective: this.Quoting.effective,
          quality: this.Quoting.quality,
          payroll: this.Quoting.payroll,
          siteType: this.Quoting.siteType,
          observation: this.Quoting.observation,
        };
        this.declarationModal.companies = defaultMethods.getItemsName(
          this.Companies.docs,
          this.Quoting.companies
        );
      }
    },

    currentProduct() {
      if (this.currentProduct !== null) {
        // get quoting
        // get contract
        // this.seedContract();
      }
    },
    Contract() {
      if (this.Contract && this.Contract._id) {
        this.initFile();

        this.seedCtr();
        this.initFileEndorsement();

        // this.contractModal.commercial = defaultMethods.getItemName(
        //   this.Users.docs,
        //   this.contractModal.commercial
        // );

        // this.contractModal.dueDate =
        //   this.contractModal.dueDate
        // this.contractModal.effectDate =
        //   this.contractModal.effectDate
        // this.contractModal.paymentDate =
        //   this.contractModal.paymentDate

        if (this.Contract.otherInfo) {
          // clause regulation
          if (this.Contract.otherInfo.regulationClause) {
            this.regulationClauseModal = this.Contract.otherInfo.regulationClause;
          }

          // pb clause
          // clause regulation
          if (this.Contract.otherInfo.pbClause) {
            this.pbClauseModal = this.Contract.otherInfo.pbClause;
          }

          // coinsurance
          if (this.Contract.otherInfo.coinsurance) {
            this.coinsuranceModal = this.Contract.otherInfo.coinsurance;
            for (let i = 0; i < this.coinsuranceModal.length; i++) {
              this.coinsuranceModal[i].company = defaultMethods.getItemName(
                this.Companies.docs,
                this.coinsuranceModal[i].company
              );
            }
          }
        }
      } else {
        this.contractModal = {
          accessory100: 0,
          accessory50: 0,
        };
      }
    },
  },

  methods: {
    ...mapActions([
      "getFile",
      "getProducts",
      "getCompanies",
      "getQuoting",
      "getUsers",
      "getContract",
      "getContracts",
      "getContractById",
      "getContracts",
      "getCompanyReturns",
      "postSearchContrat",
    ]),
    async makeSearchContract() {
      this.loader = true;
      try {
        await this.postSearchContrat({
          policeNumber: this.policeNumber,
          plugged: this.plugged,
          company: this.company,
        });
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les contrats")
        );
      }
      this.loader = false;
    },
    onEnter: function () {
      this.makeSearchContract();
    },
    startNewContract() {
      //alert(this.Contract.productName)
      this.contractModal = {
        accessory100: 0,
        accessory50: 0,
      };
      switch (this.Contract.productName) {
        case "ASSURANCE CAUTION":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSURANCE CREDIT":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSURANCE CREDIT BAIL":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "MALADIE":
          {
            this.categorie = ["MALADIE", "GESTION CONFIEE"];
          }
          break;
        case "ASSURANCES TRANSPORTS":
          {
            this.categorie = ["TERRESTRE", "MARITIME", "AERIEN", "FERROVIAIRE"];
          }
          break;
        case "AUTOMOBILE":
          {
            this.categorie = ["FLOTTE AUTO", "MONO AUTO", "FLOTTE MOTO", "MONO MOTO "];
          }
          break;


        case "BRIS DE MACHINE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "FAUX PAIEMENTS":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "GLOBALE DE BANQUE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;


        case "GLOBALE DOMMAGES":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "INDEMNITE DE FIN DE CARRIERE":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "INDIVIDUELLE ACCIDENTS CORPORELS":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;


        case "MULTIRISQUE HABITATION":
          {
            this.categorie = [
              "INCENDIE"
            ];
          }
          break;
        case "MULTIRISQUE PROFESSIONNELLE":
          {
            this.categorie = [
              "INCENDIE"
            ];
          }
          break;





        case "PREVOYANCE DECES":
          {
            this.categorie = [
              "ASSURANCES DE PERSONNES"
            ];
          }
          break;
        case "RC CHEF D'ENTREPRISE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC CHEF DE FAMILLE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RESPONSABILITE CIVILE DECENNALE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC EXPLOITATION":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "PREVOYANCE PLUS":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "RC PROFESSIONNELLE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC EVENEMENTS SPORTIFS":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RESPONSABILITE CIVILE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;


        case "TOUS RISQUES MONTAGE/ESSAI":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "VOL ":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;



        case "RC SCOLAIRE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;

        case "RETRAITE COMPLEMENTAIRE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;
        case "TOUS DOMMAGES SAUF":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "TOUS RISQUES CHANTIER":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSISTANCE AU VOYAGE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;



        case "VIOLENCE POLITIQUE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "RC TRANSPORTEUR":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "TRANSPORT DE FONDS":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "DJIGUIYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "EVACUATION SANITAIRE":
          {
            this.categorie = ["MALADIE"];
          }
          break;


        case "ASSURANCE MOYEN DE PAIEMENT":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;






        case "AUTOFINANCEMENT":
          {
            this.categorie = ["HONORAIRES PAR BENEFICIAIRE", "HONORAIRES MONTANT FIXE", "HONORAIRES MONTANT NOMINAL", "HONORAIRES CARTE SANTE", "HONORAIRES DE REGULARISATION"];
          }
          break;
        case "INCENDIE SIMPLE":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "MULTIRISQUE INDUSTRIELLE":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "AUTOMOBILE TPV":
          {
            this.categorie = ["FLOTTE AUTO", "MONO AUTO"];
          }
          break;
        case "ASSISTANCE":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "MOGOBAYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "IKENEYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "HONORAIRES BONUS COMMISSION":
          {
            this.categorie = ["BONUS /MALUS"];
          }
          break;
        case "TEMPORAIRE DECES":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "WGARAGE":
          {
            this.categorie = ["FLOTTE AUTO"];
          }
          break;
      }
      this.seedCtr();
      this.contractDialog = true;

      this.contractModal.isNew = true;
    },
    initCancelContract(item) {
      this.cancelModal = item;
      this.cancelDialog = true;
    },

    async initFileEndorsement() {
      if (this.Contract && this.Contract._id) {
        await this.getContracts({
          fromContract: this.Contract._id,
        });
      }
    },
    async init() {
      this.loader = true;
      try {
        await this.getContractById({
          id: this.$route.params.id,
        });
        await this.getCompanies();
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loader = false;
    },
    async initEndorsements() {
      this.loader = true;
      try {
        await this.getContractById({
          id: this.$route.params.id,
        });
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les avenants")
        );
      }
      this.loader = false;
    },
    // files
    async initFile() {
      this.loader = true;
      try {
        if (this.Contract && this.Contract._id) {
          await this.getFile(this.Contract.file);
        }
        // await this.getProducts({name: this.searchData});
        await this.getCompanies();
        // await this.getUsers();
        // this.initFileEndorsement();
        // this.seedContract();
        // await this.getContracts({
        //   id:this.$route.params.id
        // });
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loader = false;
    },
    closeCancel() {
      this.cancelModal = {};
      this.cancelDialog = false;
    },
    // cancel
    async saveCancelContract() {
      this.loading = true;
      try {
        // add
        await cancelContract({ id: this.cancelModal._id });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.canceledSuccessfully("Ce contrat")
        );
        this.closeCancel();
        this.init();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    editItem(item) {
      this.contractModal = Object.assign({}, item);
      if (this.Companies && this.Companies.docs) {
        this.contractModal.company = this.contractModal.company.name;
        // alert(this.Contract.productName)
      }
      switch (this.Contract.productName) {
        case "ASSURANCE CAUTION":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSURANCE CREDIT":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSURANCE CREDIT BAIL":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "MALADIE":
          {
            this.categorie = ["MALADIE", "GESTION CONFIEE"];
          }
          break;
        case "ASSURANCES TRANSPORTS":
          {
            this.categorie = ["TERRESTRE", "MARITIME", "AERIEN", "FERROVIAIRE"];
          }
          break;
        case "AUTOMOBILE":
          {
            this.categorie = ["FLOTTE AUTO", "MONO AUTO", "FLOTTE MOTO", "MONO MOTO "];
          }
          break;


        case "BRIS DE MACHINE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "FAUX PAIEMENTS":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "GLOBALE DE BANQUE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;


        case "GLOBALE DOMMAGES":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "INDEMNITE DE FIN DE CARRIERE":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "INDIVIDUELLE ACCIDENTS CORPORELS":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;


        case "MULTIRISQUE HABITATION":
          {
            this.categorie = [
              "INCENDIE"
            ];
          }
          break;
        case "MULTIRISQUE PROFESSIONNELLE":
          {
            this.categorie = [
              "INCENDIE"
            ];
          }
          break;





        case "PREVOYANCE DECES":
          {
            this.categorie = [
              "ASSURANCES DE PERSONNES"
            ];
          }
          break;
        case "RC CHEF D'ENTREPRISE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC CHEF DE FAMILLE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RESPONSABILITE CIVILE DECENNALE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC EXPLOITATION":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "PREVOYANCE PLUS":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "RC PROFESSIONNELLE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC EVENEMENTS SPORTIFS":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RESPONSABILITE CIVILE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;


        case "TOUS RISQUES MONTAGE/ESSAI":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "VOL ":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;



        case "RC SCOLAIRE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RETRAITE COMPLEMENTAIRE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;
        case "TOUS DOMMAGES SAUF":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "TOUS RISQUES CHANTIER":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSISTANCE AU VOYAGE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;



        case "VIOLENCE POLITIQUE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "RC TRANSPORTEUR":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "TRANSPORT DE FONDS":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "DJIGUIYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "EVACUATION SANITAIRE":
          {
            this.categorie = ["MALADIE"];
          }
          break;


        case "ASSURANCE MOYEN DE PAIEMENT":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;






        case "AUTOFINANCEMENT":
          {
            this.categorie = ["HONORAIRES PAR BENEFICIAIRE", "HONORAIRES MONTANT FIXE", "HONORAIRES MONTANT NOMINAL", "HONORAIRES CARTE SANTE", "HONORAIRES DE REGULARISATION"];
          }
          break;
        case "INCENDIE SIMPLE":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "MULTIRISQUE INDUSTRIELLE":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "AUTOMOBILE TPV":
          {
            this.categorie = ["FLOTTE AUTO", "MONO AUTO"];
          }
          break;
        case "ASSISTANCE":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "MOGOBAYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "IKENEYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "HONORAIRES BONUS COMMISSION":
          {
            this.categorie = ["BONUS /MALUS"];
          }
          break;
        case "TEMPORAIRE DECES":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "WGARAGE":
          {
            this.categorie = ["FLOTTE AUTO"];
          }
          break;
      }

      this.contractDialog = true;
    },

    // company return
    async initCompanyReturn() {
      try {
        await this.getCompanyReturns(this.Quoting._id);
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
    },
    closeCompanyReturn() {
      this.companyReturnModal = {};
      this.companyReturnDialog = false;
      this.customerReturnDialog = false;
    },
    editCompanyReturn(item) {
      this.companyReturnModal.accessory = item.accessory;
      this.companyReturnModal.netPrime = item.netPrime;
      this.companyReturnModal.TTCPrime = item.TTCPrime;
      this.companyReturnModal.tax = item.tax;
      this.companyReturnModal.returnDate = item.returnDate;
      this.companyReturnModal._id = item._id;
      this.companyReturnModal.company = defaultMethods.getItemName(
        this.Companies.docs,
        item.company
      );

      this.customerReturnDialog = true;
    },
    async saveCompanyReturn() {
      this.loading = true;

      try {
        const schema = {
          company: defaultMethods.getItemId(
            this.Companies.docs,
            this.companyReturnModal.company
          ),

          accessory: this.companyReturnModal.accessory,
          netPrime: this.companyReturnModal.netPrime,
          TTCPrime: this.companyReturnModal.TTCPrime,
          tax: this.companyReturnModal.tax,
          returnDate: this.companyReturnModal.returnDate,

          quoting: this.Quoting._id,
        };

        if (this.companyReturnModal._id) {
          // update
          await updateCompanyReturn({
            schema,
            id: this.companyReturnModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Retour Compagnie")
          );
          this.closeCompanyReturn();
          this.initFile();
        } else {
          // add
          await addCompanyReturn({ schema });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Retour Compagnie")
          );
          this.closeCompanyReturn();
          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    // quoting
    async saveDeclaration() {
      this.loading = true;

      try {
        const schema = {
          sinisterCompanyNumber: this.declarationModal.sinisterCompanyNumber,
          circumstance: this.declarationModal.circumstance,
          dateOfOccurrence: this.declarationModal.dateOfOccurrence,
          declarationDate: this.declarationModal.declarationDate,
          companyDispatchDate: this.declarationModal.companyDispatchDate,
          driverName: this.declarationModal.driverName,
          conductiveContact: this.declarationModal.conductiveContact,
          registrationValidationDate: this.declarationModal
            .registrationValidationDate,
          PSAP: this.declarationModal.PSAP,
          disasterObject: this.declarationModal.disasterObject,
          insuredBodilyInjury: this.declarationModal.insuredBodilyInjury,

          observation: this.declarationModal.observation,
          // file: this.File._id,
        };

        // add
        await createDeclaration({ schema, id: this.$route.params.id });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.createdSuccessfully("Declaration")
        );
        this.closeDeclaration();
        this.init();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    closeDeclaration() {
      this.declarationModal = {};
      this.sinisterDialog = false;
      // this.currentProduct = null;
    },
    async initQuoting() {
      try {
        this.loader = true;

        await this.getQuoting({
          product: this.currentProduct,
          file: this.File._id,
        });
        this.loader = false;
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
    },
    all() {
      this.panel = [...Array(this.items.length).keys()].map((k, i) => i);
    },

    select_value() {
      // get quoting
      this.initQuoting();
      // get guarentie
      // get contract
    },

    // contract
    async seedContract() {
      this.loading = true;
      try {
        if (this.File && this.File._id && this.currentProduct) {
          await this.getContract({
            id: this.File._id,
            product: this.currentProduct,
            // product: defaultMethods.getItemId(
            //   this.File.proposedProducts,
            //   this.currentProduct
            // ),
          });
        } else {
          this.Contract = {};
          this.contractModal = {};
        }
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
    seed50Accessory() {
      if (
        this.contractModal.accessory100 &&
        Number(this.contractModal.accessory100) > 0
      ) {
        this.contractModal.accessory50 = this.contractModal.accessory100 / 2;
      }
    },
    async saveContract() {
      this.loading = true;
      try {
        const schema = {
          policeNumber: this.contractModal.policeNumber,
          plugged: this.contractModal.plugged,
          actionType: this.contractModal.actionType,
          category: this.contractModal.category,
          company: defaultMethods.getItemId(
            this.Companies.docs,
            this.contractModal.company
          ),
          // commercial: defaultMethods.getItemId(
          //   this.Users.docs,
          //   this.contractModal.commercial
          // ),
          effectDate: this.contractModal.effectDate,
          dueDate: this.contractModal.dueDate,
          // paymentDate: this.contractModal.paymentDate,
          netPrime: this.contractModal.netPrime,
          // commission: this.contractModal.commission,
          totalPrime: this.contractModal.totalPrime,
          cdeaoPrime: this.contractModal.cdeaoPrime,
          observation: this.contractModal.observation,
          accessory100: this.contractModal.accessory100,
          accessory50: this.contractModal.accessory100 / 2,
        };

        if (!this.contractModal.isNew) {
          // update
          await updateContract({
            schema,
            id: this.contractModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        } else {
          // add
          schema.product = this.Contract.product;
          schema.fromContract = this.Contract._id;
          // schema.product = defaultMethods.getItemId(
          //   this.File.proposedProducts,
          //   this.currentProduct
          // );
          schema.file = this.File._id;
          await addContract({ schema, id: this.$route.params.id });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    successSaveContract() {
      this.closeContract();
      this.init();
    },
    closeContract() {
      this.contractDialog = false;
      this.seedCtr();

      // this.currentProduct = null;
      this.incorporationDialog = false;
      this.incorporationModal = {};
      this.withDrawModal = false;
      this.regulationDialog = false;
      this.pbDialog = false;
    },
    closeClause() {
      this.regulationDialog = false;
      this.pbDialog = false;
    },
    seedCtr() {
      this.contractModal = Object.assign({}, this.Contract);
      this.contractModal.isNew = true;
      if (this.Companies && this.Companies.docs) {
        this.contractModal.company = defaultMethods.getItemName(
          this.Companies.docs,
          this.contractModal.company
        );
      }
    },

    // incorporation
    async saveIncorporation() {
      this.loading = true;
      try {
        // add

        await addIncorporation({
          schema: {
            contract: this.contractModal._id,
            prospect: this.incorporationModal,
          },
          id: this.File._id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.createdSuccessfully("Incorporation")
        );
        this.closeContract();
        this.initFile();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    // retrait
    async makeWithDraw() {
      this.loading = true;
      try {
        await withdrawProspect({
          schema: {
            contract: this.contractModal._id,
            prospect: defaultMethods.getItemId(
              this.File.prospects,
              this.incorporationModal.name
            ),
          },
          id: this.File._id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.createdSuccessfully("Incorporation")
        );
        this.closeContract();
        this.initFile();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    async saveRegulation() {
      this.loading = true;
      try {
        const schema = {
          plate: this.regulationClauseModal.plate,
          reminderDate: this.regulationClauseModal.reminderDate,
          observation: this.regulationClauseModal.observation,
          companyRequestDate: this.regulationClauseModal.companyRequestDate,
          companyReturnDate: this.regulationClauseModal.companyReturnDate,
          customerRequestDate: this.regulationClauseModal.customerRequestDate,
          customerReturnDate: this.regulationClauseModal.customerReturnDate,
        };

        if (this.regulationClauseModal._id) {
          // update
          await updateRegulationClause({
            schema,
            id: this.regulationClauseModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        } else {
          // add

          await addRegulationClause({ schema, id: this.contractModal._id });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    async savePb() {
      this.loading = true;
      try {
        const schema = {
          plate: this.pbClauseModal.plate,
          reminderDate: this.pbClauseModal.reminderDate,
          observation: this.pbClauseModal.observation,
          companyRequestDate: this.pbClauseModal.companyRequestDate,
          companyReturnDate: this.pbClauseModal.companyReturnDate,
          customerRequestDate: this.pbClauseModal.customerRequestDate,
          customerReturnDate: this.pbClauseModal.customerReturnDate,
        };

        if (this.pbClauseModal._id) {
          // update
          await updatePbClause({
            schema,
            id: this.pbClauseModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        } else {
          // add

          await addPbClause({ schema, id: this.contractModal._id });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    // Reset the panel
    none() {
      this.panel = [];
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showCallEvent({ nativeEvent, event }) {
      const edit = async () => {
        this.callModal = {
          _id: event._id,
          reason: event.name,
          hour: event.hour,
          date: event.start,
        };
        // this.ModalText = {
        //   btn: "update",
        //   title: `Update ${this.program.type}`,
        // };
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.callDialog = true))
        );
      };

      if (this.callDialog) {
        this.closeCancel();
        requestAnimationFrame(() => requestAnimationFrame(() => edit()));
      } else {
        edit();
      }

      nativeEvent.stopPropagation();
    },
    getCallEvent() {
      this.events = [];

      if (!this.File || !this.File.otherInfo || !this.File.otherInfo.calls)
        return;
      for (let i = 0; i < this.File.otherInfo.calls.length; i++) {
        const program = this.File.otherInfo.calls[i];
        const date = new Date(`${program.date}`);
        const hours = program.hour.split(":");
        date.setHours(hours[0]);
        date.setMinutes(hours[1]);
        this.events.push({
          name: program.reason,
          start: date,
          end: date,
          color: "red",
          timed: true,
          hour: program.hour,
          _id: program._id,
        });
      }
    },

    // appointment
    showAppointmentEvent({ nativeEvent, event }) {
      const edit = async () => {
        this.appointmentModal = {
          _id: event._id,
          reason: event.name,
          hour: event.hour,
          location: event.location,
          date: event.start,
        };

        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.appointmentAddDialog = true))
        );
      };

      if (this.appointmentAddDialog) {
        this.closeAppointment();
        requestAnimationFrame(() => requestAnimationFrame(() => edit()));
      } else {
        edit();
      }

      nativeEvent.stopPropagation();
    },
    closeAppointment() {
      this.appointmentModal = {};
      this.appointmentAddDialog = false;
      this.appointmentDialog = false;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getAppointmentEvent() {
      this.appointmentEvents = [];

      if (
        !this.File ||
        !this.File.otherInfo ||
        !this.File.otherInfo.appointments
      )
        return;
      for (let i = 0; i < this.File.otherInfo.appointments.length; i++) {
        const program = this.File.otherInfo.appointments[i];
        const date = new Date(`${program.date}`);
        const hours = program.hour.split(":");
        date.setHours(hours[0]);
        date.setMinutes(hours[1]);
        this.appointmentEvents.push({
          name: program.reason,
          start: date,
          end: date,
          color: "blue",
          timed: true,
          hour: program.hour,
          location: program.location,
          _id: program._id,
        });
      }
    },
    async saveAppointment() {
      this.loading = true;
      try {
        if (this.appointmentModal._id) {
          // update
          await updateAppointment({
            schema: {
              reason: this.appointmentModal.reason,
              hour: this.appointmentModal.hour,
              date: this.appointmentModal.date,
              location: this.appointmentModal.location,
            },
            id: this.appointmentModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Dossier")
          );
          this.closeAppointment();
          this.initFile();
        } else {
          // add
          await addAppointment({
            schema: this.appointmentModal,
            id: this.$route.params.id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Rendez-vous")
          );
          this.closeAppointment();

          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    // proposed product
    async updateProposedProduct() {
      try {
        const schema = {
          schema: {
            name: this.File.name,
            prospects: this.File.prospects,
            phone: this.File.phone,
            email: this.File.email,
            nature: this.File.nature,
            location: this.File.location,
            description: this.File.description,
            activityField: this.File.activityField,
            birthday: this.File.birthday,
            proposedProducts: defaultMethods.getIdList(this.selectedProduct),
          },
          id: this.File._id,
        };

        await updateFile(schema);
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Dossier")
        );
        this.closeProduct();
        this.initFile();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(this.$store);
      }
    },
    closeProduct() {
      this.productDialog = false;
      this.selectedProduct = {};
    },

    seedProposedProduct() {
      this.selectedProduct = this.File.proposedProducts;
      this.proposedProductNameList = defaultMethods.getNameList(
        this.File.proposedProducts
      );
    },

    // coinsurance
    seedCoinsuranceCompanyNameList() {
      this.coinsuranceCompanyNameList = defaultMethods.getNameList(
        this.Companies.docs
      );
    },
    updateCoinsuranceCompanyNameList() {
      // seed
      this.seedCoinsuranceCompanyNameList();
      console.log("here", this.coinsuranceModal);
      for (let a = 0; a < this.coinsuranceModal.lenght; a++) {
        const coinsurance = this.coinsuranceModal[a];
        for (let i = 0; i < this.coinsuranceCompanyNameList.lenght; i++) {
          console.log(coinsurance.company, this.coinsuranceCompanyNameList[i]);
          if (coinsurance.company == this.coinsuranceCompanyNameList[i])
            this.coinsuranceCompanyNameList.splice(i, 1);
        }
      }
    },
    addOneCoinsurance() {
      this.coinsuranceModal.push({});
    },
    closeInsurance() {
      this.coinsuranceDialog = false;
      // this.currentProduct = null;
      this.contractDialog = false;

      this.coinsuranceModal = [
        {
          shareRate: 0,
          company: "",
          observation: "",
        },
      ];
      this.seedCoinsuranceCompanyNameList();
    },
    removeFromCoin(id) {
      // id -= 1;
      this.coinsuranceModal.splice(id, 1);
      this.seedCoinsuranceCompanyNameList();
    },
    async saveCoinsurance() {
      this.loading = true;
      try {
        // we need validate data
        const result = this.validCoinsuranceData(this.coinsuranceModal);
        console.log(result);
        if (!result.success)
          return defaultMethods.dispatchError(this.$store, result.message);

        const schema = {
          data: result.data,
        };
        if (this.coinsuranceModal[0]._id) {
          // update
          await updateCoinsurance({
            schema,
            id: this.contractModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("coassurance")
          );
          this.closeInsurance();
          this.initFile();
        } else {
          // add
          await addCoinsurance({
            schema,
            id: this.contractModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("coassurance")
          );
          this.closeInsurance();

          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    validCoinsuranceData(array) {
      const result = [];
      let totalRate = 0;

      const companyList = [];
      for (let i = 0; i < array.length; i++) {
        const item = array[i];

        // body validation

        // rate
        totalRate += Number(item.shareRate);

        // company
        if (companyList.includes(JSON.stringify(item.company)))
          throw new Error(
            `Duplicate company id  :${item.company} for coinsurance`
          );
        companyList.push(JSON.stringify(item.company));

        // get company id
        (item.company = defaultMethods.getItemId(
          this.Companies.docs,
          item.company
        )),
          result.push({
            shareRate: item.shareRate,
            company: item.company,
            isPayed: item.isPayed,
            observation: item.observation,
          });
      }

      if (totalRate !== 100)
        return {
          success: false,
          message: `Total shared rate must be 100,got ${totalRate}`,
        };

      return {
        success: true,
        data: result,
      };
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    addprospect(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.prospect = true;
    },
    updateprospect(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.prospect = true;
    },

    deleteItem(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.prospectdata.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.prospectdata[this.editedIndex], this.editedItem);
      } else {
        this.prospectdata.push(this.editedItem);
      }
      this.close();
    },
  },
};
</script>

<style scoped></style>
